// src/api/services/farm/farmService.js
import client from '../client';

const BASE = '/api/categories';

/** Get all farms*/
export function getCategories(includeInactive = false) {
  const params = includeInactive ? { includeInactive } : {};
  return client.get(BASE, { params }).then(res => res.data);
}

/** Get farm by id */
export function getCategoryCount() {
  return client.get(`${BASE}/count`).then(res => res.data);
}

/** Create farm */
export function createCategory(payload) {
  return client.post(BASE, payload).then(res => res.data);
}

/** Update farm */
export function getCategoryById(id) {
  return client.get(`${BASE}/${id}`).then(res => res.data);
}

/** Update business hours */
export function updateCategory(id) {
  return client.put(`${BASE}/${id}`).then(res => res.data);
}

/** Delete farm */
export function deleteCategory(id) {
    return client.delete(`${BASE}/${id}`).then(res => res.data);
}
